/* ESTASY — Product variant selection, gallery, price & availability sync. */
(function () {
  'use strict';

  class ProductForm {
    constructor(root) {
      this.root = root;
      this.variants = JSON.parse(root.querySelector('[data-variants]')?.textContent || '[]');
      this.form = root.querySelector('[data-product-form], form.product-form-ajax');
      this.idInput = root.querySelector('[data-variant-id]');
      this.priceEl = root.querySelector('[data-product-price]');
      this.submitBtn = root.querySelector('[data-add-button]');
      this.stickyPrice = document.querySelector('[data-sticky-price]');
      this.bind();
      this.update();
    }

    bind() {
      this.root.querySelectorAll('[data-variant-input]').forEach((input) => {
        input.addEventListener('change', () => this.update());
      });
      // Gallery thumbs
      this.root.querySelectorAll('[data-thumb]').forEach((thumb) => {
        thumb.addEventListener('click', () => this.selectMedia(thumb.getAttribute('data-thumb')));
      });
    }

    get selectedOptions() {
      const opts = [];
      this.root.querySelectorAll('[data-option-index]').forEach((group) => {
        const checked = group.querySelector('input:checked, select');
        if (checked) opts[parseInt(group.getAttribute('data-option-index'), 10)] = checked.value;
      });
      return opts;
    }

    currentVariant() {
      const sel = this.selectedOptions;
      return this.variants.find((v) =>
        v.options.every((opt, i) => opt === sel[i])
      );
    }

    update() {
      const variant = this.currentVariant();
      if (!variant) {
        this.setUnavailable();
        return;
      }
      if (this.idInput) this.idInput.value = variant.id;

      // update selected option labels (e.g. "Colore: Rosso")
      this.root.querySelectorAll('[data-option-index]').forEach((group) => {
        const checked = group.querySelector('input:checked');
        const label = group.querySelector('[data-selected-option]');
        if (checked && label) label.textContent = checked.value;
      });

      // price
      const priceHtml = this.renderPrice(variant);
      if (this.priceEl) this.priceEl.innerHTML = priceHtml;
      if (this.stickyPrice) this.stickyPrice.innerHTML = priceHtml;

      // availability
      if (this.submitBtn) {
        if (variant.available) {
          this.submitBtn.disabled = false;
          this.submitBtn.querySelector('[data-add-label]').textContent = this.submitBtn.getAttribute('data-label-add');
        } else {
          this.submitBtn.disabled = true;
          this.submitBtn.querySelector('[data-add-label]').textContent = this.submitBtn.getAttribute('data-label-soldout');
        }
      }

      // featured media
      if (variant.featured_media) this.selectMedia(variant.featured_media.id);

      // update URL
      if (history.replaceState) {
        const url = new URL(window.location);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url);
      }
    }

    renderPrice(variant) {
      const fmt = window.EstasyFormatMoney || ((c) => '€' + (c / 100).toFixed(2));
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        return `<span class="price price--on-sale"><span class="price__regular">${fmt(variant.compare_at_price)}</span><span class="price__sale">${fmt(variant.price)}</span></span>`;
      }
      return `<span class="price">${fmt(variant.price)}</span>`;
    }

    setUnavailable() {
      if (!this.submitBtn) return;
      this.submitBtn.disabled = true;
      this.submitBtn.querySelector('[data-add-label]').textContent = this.submitBtn.getAttribute('data-label-unavailable');
    }

    selectMedia(mediaId) {
      const main = this.root.querySelector('[data-media-main]');
      const target = this.root.querySelector(`[data-media-id="${mediaId}"]`);
      if (main && target) main.innerHTML = target.innerHTML;
      this.root.querySelectorAll('[data-thumb]').forEach((t) => {
        t.classList.toggle('is-active', t.getAttribute('data-thumb') == mediaId);
      });
    }
  }

  document.querySelectorAll('[data-product]').forEach((el) => new ProductForm(el));
})();
